import { BlockReasons } from './types';
import { reduxKey } from './constants';
function getModerationState(state) {
    return (state[reduxKey] || { deviations: {}, users: {} });
}
export function getIsUserBlocked(state, userId, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    var userState = getModerationState(state).users[userId];
    return userState ? userState.isBlocked : defaultValue;
}
export function getIsDeviationBlocked(state, deviation) {
    return !!getBlockTypeForDeviation(state, deviation);
}
export function getBlockTypeForDeviation(state, _a) {
    var deviationId = _a.deviationId, author = _a.author, blockReason = _a.blockReason;
    // if we have relevant state for this deviation, the answer is obvious
    var userState = author && getModerationState(state).users[author.userId];
    if (userState) {
        if (userState.isBlocked) {
            return BlockReasons.ArtistBlocked;
        }
        // if it was artist blocked, we override that
        if (blockReason === BlockReasons.ArtistBlocked) {
            return;
        }
    }
    var deviationState = getModerationState(state).deviations[deviationId];
    if (deviationState) {
        if (deviationState.isBlocked) {
            return BlockReasons.DeviationBlocked;
        }
        // if it was deviation blocked, we override that
        if (blockReason === BlockReasons.DeviationBlocked) {
            return;
        }
    }
    // now we are out of the overrides, can just return whatever else the deviation has
    return blockReason || undefined;
}
//# sourceMappingURL=selectors.js.map